import React, { useState } from 'react';
import { AccordionContext } from './accordion-context';
import { AccordionWrapper } from './styles';

/**
 * Should have 2 children - AccordionHeader and AccordionContent
 */
export const Accordion: React.FC<AccordionProps> = ({
  children,
  id,
  onChange,
  expanded = false,
  disabled = false,
}) => {
  const [expandedState, setExpandedState] = useState(() => expanded);

  const toggle = React.useCallback(
    event => {
      setExpandedState(!expandedState);
      if (onChange) {
        onChange(event, !expandedState);
      }
    },
    [expandedState, setExpandedState, onChange]
  );

  const context = React.useMemo(
    () => ({
      expanded: Boolean(expandedState),
      toggle,
      disabled: Boolean(disabled),
      id,
    }),
    [expandedState, toggle, disabled, id]
  );

  return (
    <AccordionWrapper aria-labelledby={id}>
      <AccordionContext.Provider value={context}>
        {children}
      </AccordionContext.Provider>
    </AccordionWrapper>
  );
};
interface AccordionProps {
  children: React.ReactElement[];
  id: string;
  expanded?: boolean;
  disabled?: boolean;
  onChange?: (event: React.MouseEvent<HTMLElement>, expanded?: boolean) => void;
}
